(function ($, Drupal) {

  "use strict";
  Drupal.behaviors.videoHeading = {
    attach: function (context, settings) {
      var video = $('video');
      var iframe = $('.video-embed-field-provider-youtube iframe');
      var overlay = $('.video-heading__overlay');

      $('.video-play-button, .video-heading__button a', context).on('click', function (e) {
        if (video.length > 0) {
          e.preventDefault();
          $(this).parent().siblings(video).attr('controls', true);
          $(this).parent().siblings(video).trigger('play');
          $(this).parent().closest(overlay).remove();

          $(this).parents().siblings('.video-heading__video').find(video).attr('controls', true);
          $(this).parents().siblings('.video-heading__video').find(video).trigger('play');
          $(this).parents().siblings('.video-heading__video').find(overlay).remove();
        }

        if (iframe.length > 0) {
          e.preventDefault();
          iframe[0].src = iframe.attr('src').split('?')[0] + '?autoplay=1&showinfo=0&rel=0&showinfo=0&modestbranding=1';
          iframe.attr('allow', 'autoplay');
        }
      });
    }
  };
})(jQuery, Drupal);
